import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import BreadCrumbs from "../../../Utils/Common/Breadcrumb";
import { AutocompleteStyle } from "../../../Utils/MuiStyles/AutocompleteStyles";
import CompletedRuns from "./CompletedRuns";
import DeletedRuns from "./DeletedRuns";
import OpenRuns from "./OpenRuns";
import RejectedRuns from "./RejectedRuns";
import useLang from "Shared/hooks/useLanguage";

const TabSelected = styled(Tab)(AutocompleteStyle());
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const NGSViewRun = () => {
  const { t } = useLang();
  const [value, setValue] = useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
        </div>
      </div>
      <div className="d-flex flex-column flex-column-fluid">
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid">
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ style: { background: "transparent" } }}
              className="min-h-auto"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-scrollButtons": {
                  width: 0,
                  transition: "width 0.7s ease",
                  "&:not(.Mui-disabled)": {
                    width: "48px",
                  },
                },
              }}
            >
              <TabSelected
                label={t("Open Runs")}
                {...a11yProps(0)}
                className="fw-bold text-capitalize"
                id="OpenRuns"
              />
              <TabSelected
                label={t("Completed Runs")}
                {...a11yProps(1)}
                className="fw-bold text-capitalize"
                id="CompletedRuns"
              />
              <TabSelected
                label={t("Deleted Runs")}
                {...a11yProps(2)}
                className="fw-bold text-capitalize"
                id="DeletedRuns"
              />
              <TabSelected
                label={t("Rejected Runs")}
                {...a11yProps(3)}
                className="fw-bold text-capitalize"
                id="RejectedRuns"
              />
            </Tabs>
            <div className="card rounded-top-0 shadow-none tab-content-card">
              <div className="card-body py-2">
                <TabPanel value={value} index={0}>
                  <OpenRuns />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <CompletedRuns />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <DeletedRuns />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <RejectedRuns />
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NGSViewRun;
